/* global window document */

import './StickyContact.scss';
import template from './StickyContact.vhtml';

export default {
	name: 'StickyContact',
	template: template,
	props: {
		contacts: {
			type: Array,
			required: true,
		},
		firstContact: {
			type: Object,
			required: true,
		},
		hide: {
			type: Boolean,
			required: false,
		},
	},
	data: () => ({
		show: false,
		showContent: false,
		showText: false,
		lastScrollTop: 0,
	}),
	computed: {
		showSticky() {
			if (this.show && !this.hide) {
				return true;
			} else {
				return false;
			}
		},
	},
	methods: {
		slideInContent() {
			if (window.innerWidth > 767) {
				this.showContent = true;
				setTimeout(() => {
					this.showText = true;
				}, 300);
			}
		},
		onScroll() {
			if (window.innerWidth > 767 ) {
				let st = window.pageYOffset || document.documentElement.scrollTop;
				if (st > this.lastScrollTop) {
					this.showText = false;
					this.showContent = false;
				} else {
					this.slideInContent();
				}
				this.lastScrollTop = st <= 0 ? 0 : st;
			}
		},
		openContactSlidein() {
			this.$emit('please-open');
		},
	},
	mounted() {
		this.show = true;
	},
};
